import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { TruthBridge } from '../components/TruthBridge';
import { SolutionSection } from '../components/SolutionSection';
import { MidPageCTA } from '../components/MidPageCTA';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-900" data-id="element-246">
      <HeroSection data-id="element-247" />
      <ProblemSection data-id="element-248" />
      <TruthBridge data-id="element-249" />
      <SolutionSection data-id="element-250" />
      <MidPageCTA data-id="element-251" />
      <DeliverablesSection data-id="element-252" />
      <AudienceSection data-id="element-253" />
      <PricingSection data-id="element-254" />
      <Footer data-id="element-255" />
    </div>;
}